<!--<div class="container-fluid">
  <div class="row">
      <div class="col">
        <p>Time 0 to 100: {{ this.t0_100 }} ms</p>
      </div>
      <div class="col">
        <p>Time 100 to 0: {{ this.t100_0 }} ms</p>
      </div>
      <div class="col">
        <p>Time 0 to 50: {{ this.t0_50 }} ms</p>
      </div>
      <div class="col">
        <p>Time 50 to 0: {{ this.t50_0 }} ms</p>
      </div>
      <div class="col">
        <p>Time 50 to 100: {{ this.t50_100 }} ms</p>
      </div>
      <div class="col">
        <p>Time 100 to 50: {{ this.t100_50 }} ms</p>  
      </div>
      <div class="col">
        <p>Time Slits: {{ this.tSlits }} ms</p>
      </div>
  </div>    

      <form>          
          <div class="form-group">
            <label for="directionSelect">Direction</label>
            <select class="form-control" id="directionSelect" name="directionSelect" [(ngModel)]="this.dir">
              <option value="0">Up</option>
              <option value="1">Down</option>              
            </select>
          </div>          
          <div class="form-group">
            <label for="timeInput">Time in seconds</label>
            <input class="form-control" id="timeInput" name="timeInput" type="number" [(ngModel)]="this.tMove">
          </div>          
          <button type="button" class="btn btn-primary mb-2" (click)="this.move()">Move</button>
        </form>
  <div class="row">
    <div class="col">
        <p>Shutter position: {{ this.position }} %</p>
        <p>Slit position: {{ this.positionSlit }} %</p>
    </div>
  </div>
</div>-->

<div class="container shutter">
  <div id="wrapper" class="wrapper">
    <div *ngFor="let i of currentBlind | times"          
      @blinds @slits class="blind" [ngStyle]="{'border-top-style':stylesBlind[i-1]}">      
  </div>
     <!--<div id="blind0" class="blind blind0" [@shrinkOut]="'in'"></div>  
     <div id="blind1" class="blind blind1" [@shrinkOut]="this.dir==='0'?'in':'in'"></div>     
     <div id="blind2" class="blind blind2" [@shrinkOut]="this.dir==='0'?'in':'in'"></div>     
     <div id="blind3" class="blind blind3" [@shrinkOut]="this.dir==='0'?'in':'in'"></div>     
     <div id="blind4" class="blind blind4" [@shrinkOut]="this.dir==='0'?'in':'in'"></div>     
     <div id="blind5" class="blind blind5" [@shrinkOut]="this.dir==='0'?'in':'in'"></div>     
     <div id="blind6" class="blind blind6" [@shrinkOut]="this.dir==='0'?'in':'in'"></div>     
     <div id="blind7" class="blind blind7" [@shrinkOut]="this.dir==='0'?'in':'in'"></div>     
     <div id="blind8" class="blind blind8" [@shrinkOut]="this.dir==='0'?'in':'in'"></div>     
     <div id="blind9" class="blind blind9" [@shrinkOut]="this.dir==='0'?'in':'in'"></div>-->     

  </div>
</div>

<!--<button (click) = "this.move()">MOVE</button>-->
